<div class="dial-container">
  <h1 mat-dialog-title>{{ dialInfo.title }}</h1>
  <div mat-dialog-content>
    <div class="text">{{ dialInfo.description }}</div>
    <mat-divider style="margin: 20px 0"></mat-divider>
    <div class="form-container">
      @for (field of dialInfo.formDef; track field.id) {
        @switch (field.type) {
          @case ('date') {
            <mat-form-field appearance="fill">
              <mat-label>Choose a date</mat-label>
              <input [(ngModel)]="data[field.id]" [matDatepicker]="picker" matInput />
              <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          }
          @case ('textArea') {
            <mat-form-field class="edit-text-field-area">
              <mat-label>{{ field.label }}</mat-label>
              <textarea
                [(ngModel)]="data[field.id]"
                cdkAutosizeMaxRows="20"
                cdkAutosizeMinRows="1"
                cdkTextareaAutosize
                matInput></textarea>
            </mat-form-field>
          }
          @case ('option') {
            <mat-form-field appearance="fill">
              <mat-label>{{ field.label }}</mat-label>
              <mat-select [(ngModel)]="data[field.id]" multiple>
                @for (opt of field.options ?? []; track opt) {
                  <mat-option [value]="opt">{{ opt }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @case ('bool') {
            <mat-checkbox [(ngModel)]="data[field.id]">{{ field.label }}</mat-checkbox>
          }
          @default {
            <mat-form-field>
              <mat-label>{{ field.label }}</mat-label>
              <input [(ngModel)]="data[field.id]" [type]="field.type" matInput />
            </mat-form-field>
          }
        }
      }
    </div>
  </div>
  <mat-divider style="margin: 0 20px"></mat-divider>
  <div class="button-row" mat-dialog-actions>
    <button (click)="onCancel()" class="selector abort-button" mat-raised-button>Cancel</button>
    <button (click)="onConfirm()" class="selector accept-button" color="primary" mat-raised-button>
      Confirm
    </button>
  </div>
</div>
